import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full px-4 md:px-6 py-14 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20abstract%20gradient%20background%20with%20soft%20orange%20and%20teal%20flowing%20waves%2C%20modern%20digital%20art%20style%2C%20smooth%20curves%2C%20cinematic%20lighting%2C%20elegant%20composition&width=1600&height=600&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50"></div>
      </div>
      <div className="relative z-10 max-w-[1280px] mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
          准备好开始你的娱乐之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-white/70 max-w-lg mx-auto mb-8">
          无需注册，完全免费。五万部高清资源等你来发现，现在就加入俺去也，开启无限精彩。
        </p>
        <Link
          to="/category/dianying"
          className="inline-flex items-center px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-all whitespace-nowrap shadow-lg hover:shadow-xl"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          <i className="ri-rocket-line mr-2"></i>
          立即体验
        </Link>
      </div>
    </section>
  );
}